export enum VoteOptionEnum {
    Invalid = -1,
    NoVote = 0,
    Yes = 1,
    No = 2,
    Abstention = 3
}
